import React, {useEffect, useState} from 'react';
import {List, Skeleton} from "antd";
import GroupPending from "../../../../components/Pending/GroupPending";
import useFetch from "use-http";

interface GroupRequestsProps {
    groupId: string
    onNoRequests: () => void
}

export const GroupRequests: React.FunctionComponent<GroupRequestsProps> = (props) => {

    const [pendingRequests, setPendingRequests] = useState<any>([]);
    const { get, post, response, loading, error } = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v2/groups")
    const [loaded, setLoaded] = useState<boolean>(false);

    const getPendingRequest = async (id: string) => {
        const initPendingReq = await get(`/pending-request/${id}`)
        if (response.ok) setPendingRequests(initPendingReq)
        setLoaded(true);
    }

    const onDecline = async (txId: string) => {
        await post(`/reject`, { id: txId });
        if (response.ok) {
            setPendingRequests((reqs: any) => reqs.filter((req: any) => {
                return req?.id !== txId
            }));
        }
    }

    const onAccept = async (txId: string) => {
        await post(`/accept`, { id: txId });
        if (response.ok) {
            setPendingRequests((reqs: any) => reqs.filter((req: any) => {
                return req?.id !== txId
            }));
        }
    }

    useEffect(() => {
        if (!props.groupId) return
        getPendingRequest(props.groupId);
    }, [props.groupId])

    useEffect(() => {
        if (!loaded) return;
        if (pendingRequests.length !== 0) return;
        props.onNoRequests();
    }, [pendingRequests, loaded])

    return (
        <List
            className="demo-loadmore-list"
            loading={loading}
            itemLayout="horizontal"
            // loadMore={loadMore}
            // style={{ padding: "0 1rem"}}
            dataSource={pendingRequests}
            renderItem={(req: any) => (
                <List.Item style={{borderBottom: "none", paddingTop: 0}}>
                    <Skeleton avatar title={false} loading={false} active>
                        {/*<div>test</div>*/}
                        <GroupPending
                            id={req?.id}
                            imgURL={req?.user?.imageProfileURL}
                            name={req?.user?.firstname}
                            date={req?.updatedAt}
                            onDecline={onDecline}
                            onAccept={onAccept}
                        />
                    </Skeleton>
                </List.Item>
            )}
        />
    )
}